import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { INITIALIZE_STATE_FROM_STORAGE } from '../types';
import storage from '../../../services/storage';
import { loadCart, modifyCart } from '../cart';
import { handleCallback, getToken } from '../auth';
import { getParam } from '../../../utils/url';
import { setCookieFromParam } from '../../../utils/cookies';
import { loadUser } from '../user';
var clearFinalizedOrderFromStorage = function clearFinalizedOrderFromStorage() {
  try {
    var checkoutSessionId = getParam('checkout_session_id');
    var finalizedOrderNumber = getParam('number');
    var cartNumber = storage.getItem('cart-number');
    if (checkoutSessionId && finalizedOrderNumber && finalizedOrderNumber === cartNumber) {
      storage.removeItem('cart-number');
      storage.removeItem('cart-token');
    }
  } catch (error) {
    console.error(error);
  }
};
var persistTrackingParams = function persistTrackingParams() {
  setCookieFromParam('ir_click_id');
};
export var initializeStateFromStorage = function initializeStateFromStorage() {
  var payload = {
    auth: {
      isLoggedIn: storage.getItem('auth-logged-in')
    },
    cart: {
      isFetching: true,
      data: {
        number: storage.getItem('cart-number'),
        token: storage.getItem('cart-token')
      }
    }
  };
  return {
    type: INITIALIZE_STATE_FROM_STORAGE,
    payload: payload
  };
};
export var initializeState = function initializeState() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var auth, authToken, _authToken, referralIdentifier;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            clearFinalizedOrderFromStorage();
            _context.prev = 2;
            _context.next = 5;
            return dispatch(initializeStateFromStorage());
          case 5:
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            console.error(_context.t0);
          case 10:
            _context.prev = 10;
            _context.next = 13;
            return dispatch(loadCart());
          case 13:
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t1 = _context["catch"](10);
            console.error(_context.t1);
          case 18:
            if (!auth) {
              _context.next = 101;
              break;
            }
            if (!(typeof auth.currentUrlHandlesCallback === 'function')) {
              _context.next = 71;
              break;
            }
            if (!auth.currentUrlHandlesCallback()) {
              _context.next = 52;
              break;
            }
            authToken = getParam('magic_credential') || getParam('auth_credential');
            if (!authToken) {
              _context.next = 33;
              break;
            }
            _context.prev = 23;
            _context.next = 26;
            return dispatch(handleCallback());
          case 26:
            _context.next = 31;
            break;
          case 28:
            _context.prev = 28;
            _context.t2 = _context["catch"](23);
            console.error(_context.t2);
          case 31:
            _context.next = 41;
            break;
          case 33:
            _context.prev = 33;
            _context.next = 36;
            return dispatch(getToken());
          case 36:
            _context.next = 41;
            break;
          case 38:
            _context.prev = 38;
            _context.t3 = _context["catch"](33);
            console.error(_context.t3);
          case 41:
            if (!getState().auth.token) {
              _context.next = 50;
              break;
            }
            _context.prev = 42;
            _context.next = 45;
            return dispatch(loadUser());
          case 45:
            _context.next = 50;
            break;
          case 47:
            _context.prev = 47;
            _context.t4 = _context["catch"](42);
            console.error(_context.t4);
          case 50:
            _context.next = 69;
            break;
          case 52:
            _context.prev = 52;
            _context.next = 55;
            return dispatch(getToken());
          case 55:
            _context.next = 60;
            break;
          case 57:
            _context.prev = 57;
            _context.t5 = _context["catch"](52);
            console.error(_context.t5);
          case 60:
            if (!getState().auth.token) {
              _context.next = 69;
              break;
            }
            _context.prev = 61;
            _context.next = 64;
            return dispatch(loadUser());
          case 64:
            _context.next = 69;
            break;
          case 66:
            _context.prev = 66;
            _context.t6 = _context["catch"](61);
            console.error(_context.t6);
          case 69:
            _context.next = 101;
            break;
          case 71:
            if (!(typeof auth.currentUrlHandlesCallback === 'undefined')) {
              _context.next = 101;
              break;
            }
            _authToken = getParam('magic_credential') || getParam('auth_credential');
            if (!_authToken) {
              _context.next = 84;
              break;
            }
            _context.prev = 74;
            _context.next = 77;
            return dispatch(handleCallback());
          case 77:
            _context.next = 82;
            break;
          case 79:
            _context.prev = 79;
            _context.t7 = _context["catch"](74);
            console.error(_context.t7);
          case 82:
            _context.next = 92;
            break;
          case 84:
            _context.prev = 84;
            _context.next = 87;
            return dispatch(getToken());
          case 87:
            _context.next = 92;
            break;
          case 89:
            _context.prev = 89;
            _context.t8 = _context["catch"](84);
            console.error(_context.t8);
          case 92:
            if (!getState().auth.token) {
              _context.next = 101;
              break;
            }
            _context.prev = 93;
            _context.next = 96;
            return dispatch(loadUser());
          case 96:
            _context.next = 101;
            break;
          case 98:
            _context.prev = 98;
            _context.t9 = _context["catch"](93);
            console.error(_context.t9);
          case 101:
            referralIdentifier = getParam('ref');
            if (!referralIdentifier) {
              _context.next = 111;
              break;
            }
            _context.prev = 103;
            _context.next = 106;
            return dispatch(modifyCart({
              attributes: {
                referralIdentifier: referralIdentifier
              }
            }));
          case 106:
            _context.next = 111;
            break;
          case 108:
            _context.prev = 108;
            _context.t10 = _context["catch"](103);
            console.error(_context.t10);
          case 111:
            persistTrackingParams();
          case 112:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 7], [10, 15], [23, 28], [33, 38], [42, 47], [52, 57], [61, 66], [74, 79], [84, 89], [93, 98], [103, 108]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};